import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { RouterStateService } from '~services/router-state.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-orders-modal',
  styleUrls: ['./lmo-orders-modal.component.scss'],
  templateUrl: './lmo-orders-modal.component.html',
})
export class LmoOrdersModalComponent implements OnInit {
  @ViewChild('modal', { static: true }) private modal: TemplateRef<any>;
  constructor(private matDialog: MatDialog, private routerState: RouterStateService, private router: Router) {}
  public ngOnInit() {
    // Avoids expression changed after it has been checked errors
    Promise.resolve().then(() => {
      const dialog = this.matDialog.open(this.modal, {
        minWidth: '500px',
      });
      dialog
        .afterClosed()
        .pipe(
          switchMap(() => this.routerState.routerState$),
          take(1),
        )
        .subscribe((state) => {
          // When closed, we want to update the url to everything before the word order
          const fullUrl = state.url.split('/');
          const ordersIndex = fullUrl.indexOf('order');
          if (ordersIndex !== -1) {
            let parentUrl = fullUrl.slice(0, ordersIndex);
            if (state.url.startsWith('/')) {
              parentUrl = ['/', ...parentUrl];
            }
            parentUrl = parentUrl.filter((segment) => segment.length > 0);
            this.router.navigate(parentUrl);
          }
        });
    });
  }
}
